export const POLYGON_ZKEVM_TOKEN_WHITELIST = []
export const POLYGON_ZKEVM_TOKEN_BLACKLIST = []